import { render } from "./CheckBoxes.vue?vue&type=template&id=7caa6c36&scoped=true"
import script from "./CheckBoxes.vue?vue&type=script&lang=js"
export * from "./CheckBoxes.vue?vue&type=script&lang=js"

import "./CheckBoxes.vue?vue&type=style&index=0&id=7caa6c36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caa6c36"]])

export default __exports__